import { forwardRef } from "react";
import { Form, Settings, SettingsItem, Select } from "ui";
import { MenuItem } from "@mui/material";
import DinteroModel from "./types/DinteroModel";
import FormRef from "../types/FormRef";

type DinteroUpdateFormProps = {
    data: DinteroModel;
    errors: any;
    loading: boolean;
    onSubmit: (data: DinteroModel) => void;
};

const DinteroUpdateForm = forwardRef<FormRef, DinteroUpdateFormProps>(
    ({ data, errors, loading, onSubmit }, ref) => {
        return (
            <Form
                ref={ref}
                data={data}
                errors={errors}
                fields={{
                    environment: { default: "production" },
                    payment_methods: { default: [] },
                }}
                loading={loading}
                onSubmit={onSubmit}
                preventLeftForm
                unsaved={false}
            >
                {(context: any) => {
                    return (
                        <>
                            <Settings>
                                <SettingsItem label="Environment">
                                    <Select
                                        fullWidth
                                        id="environment"
                                        margin="none"
                                    >
                                        <MenuItem value="test">Test</MenuItem>
                                        <MenuItem value="production">
                                            Production
                                        </MenuItem>
                                    </Select>
                                </SettingsItem>
                            </Settings>
                        </>
                    );
                }}
            </Form>
        );
    },
);

export default DinteroUpdateForm;
